import { LinkItem } from '@occc/ui-design-system';

import { routeCreator } from '../utils';

export const breadcrumbLinks: LinkItem[] = [
  {
    to: routeCreator.list(),
    label: 'User Management',
  },
  {
    key: 'Edit User',
    label: 'Edit User',
  },
];
